import { UpsellCardSpotlightComponentProps } from '../../../models/upsell-card-props';
import { ActionButton, DismissButton } from '../../UpsellCardButtons';
import styles from './UpsellCardSpotlightMint.module.css';

export const UpsellCardSpotlightMint: React.FC<UpsellCardSpotlightComponentProps> = ({
    title,
    description,
    action,
    dismiss,
    background,
    badge,
    eyebrow,
}) => (
    <s-section padding="none">
        <div
            className={`relative flex h-full flex-col items-center justify-between px-7 pt-7 pb-7 text-center shadow-sm md:card-fix-height ${styles.card}`}
            style={background ? { background } : undefined}
        >
            {dismiss && (
                <div className={'absolute top-2 right-2'}>
                    <DismissButton dismiss={dismiss} />
                </div>
            )}
            {badge && (
                <span className={`mb-2 rounded-md px-2 py-0.5 text-xs font-semibold text-white ${styles.badge}`}>
                    {badge}
                </span>
            )}
            <div className="flex flex-col gap-2 justify-between">
                <div className="flex flex-col gap-0.5 pb-1">
                    {eyebrow && <div className={`text-body-sm font-bold uppercase ${styles.eyebrow}`}>{eyebrow}</div>}
                    <div className="text-hading-lg font-semibold">{title}</div>
                </div>
                <div className="pb-0.5">{description}</div>
            </div>
            {action && <ActionButton action={action} />}
        </div>
    </s-section>
);
